import React from 'react';
import { PMNode, Process } from '../../types';
import type { Segment } from '../../migrations/legacyEdge';
import Node from './Node';
import { buildNodeSemanticMap } from '../../utils/mapping/semanticStyles';

interface NodeLayerProps {
  nodes:          Record<string, PMNode>;
  processes:      Process[];
  edges:          Segment[];
  selectedNodeId: string | null;
  inFlowNodes:    Record<string, string>; // nodeId -> color
  onMouseDown:    (e: React.MouseEvent, id: string) => void;
  onClick:        (e: React.MouseEvent, id: string) => void;
  onDblClick:     (e: React.MouseEvent, id: string) => void;
  playbackNodeState?: Record<string, boolean> | null;
}

const NodeLayer: React.FC<NodeLayerProps> = ({
  nodes, processes, edges, selectedNodeId, inFlowNodes,
  onMouseDown, onClick, onDblClick, playbackNodeState = null,
}) => {
  const semanticNodes = buildNodeSemanticMap(processes, edges);

  return (
    <g id="layer-nodes">
      {Object.values(nodes).map(n => (
        <Node
          key={n.id}
          n={n}
          semanticOperator={semanticNodes[n.id] ?? 'normal'}
          isSelected={n.id === selectedNodeId}
          isInFlow={n.id in inFlowNodes}
          flowColor={inFlowNodes[n.id]}
          onMouseDown={e => onMouseDown(e, n.id)}
          onClick={e => onClick(e, n.id)}
          onDblClick={e => onDblClick(e, n.id)}
          isPlaybackVisible={playbackNodeState ? Boolean(playbackNodeState[n.id]) : true}
        />
      ))}
    </g>
  );
};

export default NodeLayer;
